import BookingAndRetrievalCount from "../../../components/Reports/BookingRetrievalCountReport"

const BookingRetrievalCountPage = () => {
    return <BookingAndRetrievalCount/>
}

export default BookingRetrievalCountPage;